// extracted by mini-css-extract-plugin
export default {"page":"Delivery_page__JjfFC"};